import { Flex } from "@chakra-ui/react";

const NotFound = () => <Flex>Not Found :(</Flex>;

export default NotFound;
